"use client";

import { Link, redirect, useRouter } from "@/i18n/routing";
import { Button } from "@heroui/button";
import { Code } from "@heroui/react";
import { useLocale, useTranslations } from "next-intl";
// import { useEffect } from "react";
import Image from "next/image";

export default function Error({ error, reset }: { error: Error; reset: () => void }) {
  // const router = useRouter();
  const t = useTranslations();
  const isUnauthorized = /401/g.test(error.message);
  // useEffect(() => {
  //   // // Log the error to an error reporting service
  //   // /* eslint-disable no-console */
  //   // console.log(error.message);
  //   // if (/401/g.test(error.message)) {
  //   //   console.error("UNAUTHORIZED");
  //   //   redirect({ locale, href: "/logout" });
  //   // }
  // }, [error]);

  return (
    <div className="min-h-[calc(100svh-var(--main-navbar-height)-var(--misc-dl-height))] flex h-full w-full flex-col items-center justify-center px-4 text-center mx-4">
      {isUnauthorized ? (
        <div className="flex h-full w-full flex-col items-center justify-center">
          <h2 className="text-2xl font-thin text-primary">{t("session-ended-title")}</h2>
          <Button as={Link} href="/logout">
            {t("session-ended-description")}
          </Button>
        </div>
      ) : (
        <div className="flex h-full w-full flex-col items-center justify-center space-y-4 [&>*]:z-10">
          <Image src="/maha_logo1.webp" width={300} height={300} alt="" className="absolute !z-0 opacity-5" />
          {/* <Code>{error.name}</Code> */}
          <h2 className="text-2xl font-thin text-primary">{error.name}</h2>
          <Code>{error.message}</Code>
          <Button onPress={reset} className="gradient-secondary w-full max-w-48 text-white drop-shadow-md">
            {t("try-again")}
          </Button>
        </div>
      )}
    </div>
  );
}
